/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/address';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "Ssn": {
                    "fields": {
                      "value": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "last4": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ControllingIndividual": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "givenName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "surname": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "squareup.connect.v2.resources.Address",
                        "id": 4,
                        "rule": "optional"
                      },
                      "birthDate": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "isManager": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "hasSignificantOwnership": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "ssn": {
                        "type": "squareup.sfs.external.models.Ssn",
                        "id": 6
                      }
                    },
                    "nested": {
                      "government_id": {
                        "oneof": ["ssn"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Ssn && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ControllingIndividual) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Ssn @ squareup/sfs/external/models/controlling_individual.proto at 8:1
 */
export const Ssn = $root.lookupType('squareup.sfs.external.models.Ssn');
fixType(Ssn);
Builder.createAndAttachToType(Ssn);
/**
 * --
 * @desc Represents a controlling individual on an SFS ApplicationFlow.
 * --
 *
 * SOURCE ControllingIndividual @ squareup/sfs/external/models/controlling_individual.proto at 21:1
 */
export const ControllingIndividual = $root.lookupType('squareup.sfs.external.models.ControllingIndividual');
fixType(ControllingIndividual);
Builder.createAndAttachToType(ControllingIndividual);